import axios from "../plugins/axios";

// const defaultIncludes = [];

export default {
  paginateByStaticSearch(
    staticSearchId, page, perPage, orderBy, order, includes = [], filter, routeParameters = {},
  ) {
    const uri = `/web_api/v1/static_selection/static_search/${staticSearchId}`;
    const params = {
      page,
      perPage,
      orderBy,
      order,
      include: includes,
    };
    Object.keys(routeParameters).forEach((key) => {
      params[`route_parameters[${key}]`] = routeParameters[key];
    });
    return axios.post(uri, {
      static_search_id: staticSearchId,
      filter,
    }, {
      params,
    }).then((response) => response.data);
  },
};
